import React, { useState, useRef, useEffect } from "react";

import TermsDoc from "./TermsDoc";

const TermsnConditions = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef(null);

  // const check = ()=>{
  //   props.check();
  // }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update the state when the target element becomes visible
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 } // set the threshold to 0.5, which means the element is considered visible when at least 50% of it is in view
    );

    // Start observing the target element
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    // Stop observing the target element when the component unmounts
    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);
  return (
    <>
      <div
        className="z-50 fixed bg-black bg-opacity-20 backdrop-blur top-0 left-0 w-full h-full px-4 outline-none overflow-x-hidden overflow-y-auto"
        id="exampleModalScrollable"
        tabindex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-lg my-6 mx-auto relative w-auto pointer-events-none">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52]  dark:bg-gray-700 bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-medium leading-normal text-gray-200"
                id="exampleModalScrollableLabel"
              >
                Terms & Conditions
              </h5>
            </div>
            <div className="flex-auto text-white overflow-y-auto relative p-4">
              <TermsDoc targetRef = {targetRef}/>
            </div>
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 rounded-b-md">
              {isVisible &&
              <button
                onClick={() =>{ props.check(); props.modalTermsClose()}}
                type="button"
                className="inline-block px-6 py-2.5 bg-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-400 hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 transition duration-150 ease-in-out ml-1"
              >
                {props.button}
              </button>
                }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsnConditions;
